var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-container"},[_c('Picker',{attrs:{"title":((_vm.$t('choose')) + "..."),"emoji":"point_up","color":"#FE9500","data":_vm.emojiIndex,"i18n":{
      search: _vm.$t('find-your-emoji'),
      notfound: _vm.$t('no-emoji-found'),
      categories: {
        search: _vm.$t('search-results'),
        recent: _vm.$t('frequently-used'),
        smileys: _vm.$t('smileys-and-emoticon'),
        people: _vm.$t('people-and-body'),
        nature: _vm.$t('animals-and-nature'),
        foods: _vm.$t('food-and-drink'),
        activity: _vm.$t('activity'),
        places: _vm.$t('travel-and-places'),
        objects: _vm.$t('objects'),
        symbols: _vm.$t('symbols'),
        flags: _vm.$t('flags'),
        custom: _vm.$t('custom'),
      },
    }},on:{"select":_vm.select,"skin-change":_vm.skinChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }